import { computed, makeAutoObservable } from 'mobx';
import React from 'react';
import moment from 'moment';
import { AppState, useAppStateContext } from 'src/AppState/AppState';
import { ShortEventsList } from 'src/components/TradingEvents/ShortEventsList/ShortEventsList';
import { observer } from 'src/utils/mobx-react';
import { EventsCollectionQueryType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import { EventsCollectionQueryModel } from 'src_common/common/websocket2/models/EventsCollectionQueryModel';

class State {
    constructor(private readonly appState: AppState) {
        makeAutoObservable(this);
    }

    @computed private get allEventsList(): EventsCollectionQueryModel | null {
        const query: EventsCollectionQueryType = {
            'startTime[from]': moment().startOf('day').toISOString(),
            'startTime[to]': moment().endOf('day').toISOString(),
            started: false,
        };

        return this.appState.websocketV2.getEventQuery(query);
    }

    @computed get eventIds(): Array<number> {
        if (this.allEventsList === null) {
            return [];
        }

        const allEvents = this.allEventsList.events;

        allEvents.sort((a, b) => a.startTime - b.startTime);

        return allEvents.map((item) => item.id).slice(0, 10);
    }
}

export const NextEventsList = observer('NextEventsList', () => {
    const appState = useAppStateContext();
    const [state] = React.useState(() => new State(appState));

    return <ShortEventsList events={state.eventIds} />;
});
